var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingcard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.57974,
    y: 1.8157,
    width: 51.5578,
    height: 51.5578,
    rx: 25.7789,
    stroke: "#0F9BFB",
    strokeOpacity: 0.1,
    strokeWidth: 1.77778
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.46863,
    y: 2.70459,
    width: 49.78,
    height: 49.78,
    rx: 24.89,
    fill: "url(#paint0_radial_136_1599)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.91307,
    y: 3.14903,
    width: 48.8911,
    height: 48.8911,
    rx: 24.4456,
    stroke: "#006EC2",
    strokeOpacity: 0.1,
    strokeWidth: 0.888889
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2042 17.6366C22.8978 22.9197 31.7272 22.8334 37.3165 17.44C32.0334 23.1336 32.1197 31.963 37.5131 37.5523C31.8195 32.2692 22.99 32.3555 17.4008 37.7489C22.6839 32.0553 22.5976 23.2258 17.2042 17.6366Z",
    fill: "url(#paint1_radial_136_1599)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_1599",
    x: 11.8709,
    y: 15.6622,
    width: 30.9755,
    height: 30.9757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0038961 0 0 0 0 0.576623 0 0 0 0 0.896104 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_1599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_1599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_136_1599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3586 41.373) rotate(90) scale(29.3346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3998E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_136_1599",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3586 27.5944) rotate(44.44) scale(47.6991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingcard2);
export default __webpack_public_path__ + "static/media/pricingcard2.6d8d7ec6c1e9c89142bc7309b7c0131d.svg";
export { ForwardRef as ReactComponent };